// extracted by mini-css-extract-plugin
module.exports = {"brands":"_brands-styles-module--brands--1yL85"};